export class PortalMenuPreferences {
    PortalMenus: PortalMenuItem[];
}

export class PortalMenuItem {
    ParentGroupName: string;
    GroupName: string;
    GroupIcon: string;
    Expanded: number;
    Id: number;
}